var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2217_6719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 29V14.5379C4 13.7262 4.49055 12.995 5.2416 12.6873L23.6355 5.14937C23.8762 5.05074 24.1338 5 24.3939 5H32.5",
    stroke: "#26BC96",
    strokeWidth: 3.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 27H30",
    stroke: "#98249A",
    strokeWidth: 3.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 47L6 47C4.89543 47 4 47.8954 4 49L4 53C4 54.1046 4.89543 55 6 55L30 55",
    stroke: "#0A70B8",
    strokeWidth: 3.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 31V43",
    stroke: "#FBBF00",
    strokeWidth: 3.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 31V43",
    stroke: "#A9D726",
    strokeWidth: 3.75
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2217_6719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5884 3H30V29H56C57.1046 29 58 28.1046 58 27V13.7719C58 12.9726 57.5241 12.25 56.7897 11.9344L36.3781 3.1625C36.1287 3.05529 35.86 3 35.5884 3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 29,
    width: 3.75,
    height: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 45H56C57.1046 45 58 45.8954 58 47V55C58 56.1046 57.1046 57 56 57H30V45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    width: 3.75,
    height: 16,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2217_6719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 54,
    fill: "white",
    transform: "translate(2 3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2217_6719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 54,
    fill: "white",
    transform: "matrix(-1 0 0 1 58 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankActive);
export default __webpack_public_path__ + "static/media/BankActive.f2287747e5080d2b2b9f3980e186c18a.svg";
export { ForwardRef as ReactComponent };